import { DrawerActions } from '@react-navigation/native';
import { Stack, useNavigation } from 'expo-router';
import React from 'react';
import { Pressable } from 'react-native';

import { IconSymbol } from '@/components/ui/IconSymbol';

export default function CampaignLayout() {
  const navigation = useNavigation();

  return (
    <Stack
      screenOptions={{
        headerLeft: ({ tintColor }) => (
          <Pressable onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())} style={{ marginLeft: 16 }}>
            <IconSymbol name="chevron.right" size={28} color={tintColor || '#000'} />
          </Pressable>
        ),
      }}
    >
      <Stack.Screen name="telling" options={{ title: 'Telling', headerShown: false }} />
      <Stack.Screen name="canvass" options={{ title: 'Canvass', headerShown: false }} />
      <Stack.Screen name="leafleting" options={{ title: 'Leafleting', headerShown: false }} />
      <Stack.Screen name="phone" options={{ title: 'Phone', headerShown: false }} />
      <Stack.Screen name="settings" options={{ title: 'Settings' }} />
      <Stack.Screen name="index" options={{ title: 'Loading...' }} />
    </Stack>
  );
}
